export const productRulesApi = {
  // PRODUCT GROUPS
  getProductGroups: client =>
    client('product-rules/product-groups', {method: 'GET'}),

  createProductGroup: (client, payload) =>
    client('product-rules/product-groups', {method: 'POST', data: payload}),

  deleteProductGroup: (client, groupName) =>
    client(`product-rules/product-groups/${encodeURIComponent(groupName)}`, {
      method: 'DELETE',
    }),

  addPlanCode: (client, groupName, code) =>
    client(`product-rules/product-groups/plan-code`, {
      method: 'POST',
      data: {groupName, code},
    }),

  updatePlanCode: (client, groupName, oldCode, newCode) =>
    client(`product-rules/product-groups/plan-code`, {
      method: 'PUT',
      data: {groupName, oldCode, newCode},
    }),

  deletePlanCode: (client, groupName, code) =>
    client(
      `product-rules/product-groups/plan-code/${encodeURIComponent(
        groupName,
      )}/${encodeURIComponent(code)}`,
      {method: 'DELETE'},
    ),

  // SERVICE ID RULES
  getServiceIdRules: (client, filters) => {
    const queryParams = new URLSearchParams({
      ...filters,
    }).toString()

    return client(`product-rules/service-id-rules?${queryParams}`, {
      method: 'GET',
    })
  },
  createServiceIdRule: (client, payload) =>
    client('product-rules/service-id-rules', {method: 'POST', data: payload}),

  updateServiceIdRule: (client, data) =>
    client(`product-rules/service-id-rules`, {method: 'PUT', data}),

  deleteServiceIdRule: (client, payload) => {
    const queryParams = new URLSearchParams({
      ...payload,
    }).toString()
    return client(`product-rules/service-id-rules?${queryParams}`, {
      method: 'DELETE',
    })
  },
}
